import { CodigosNotificacion } from "@/constants/enums";

interface BuildPatchedBodyProps {
  detail: any;
  bodyHasParams: boolean;
  splitBody: any;
  newSuffix: string;
}

export const buildPatchedBody = ({
  detail,
  bodyHasParams,
  splitBody,
  newSuffix,
}: BuildPatchedBodyProps) => {
  if (!detail?.cuerpo) return String(newSuffix ?? "");
  if (!bodyHasParams) return String(newSuffix ?? "");

  const original = detail.cuerpo;
  const tokens = splitBody(original);

  const lastTextIndex = (() => {
    for (let i = tokens.length - 1; i >= 0; i -= 1) {
      if (tokens[i]?.type === "text") return i;
    }
    return -1;
  })();

  if (lastTextIndex === -1) {
    return `${original}${String(newSuffix ?? "")}`;
  }

  const updated = tokens.map(
    (
      t: {
        type: "text" | "param";
        value: string;
      },
      idx: number,
    ) => {
      if (idx !== lastTextIndex) return t.value;
      return String(newSuffix ?? "");
    },
  );

  return updated.join("");
};

interface BuildPreviewBodyProps {
  detail: any;
  bodyHasParams: boolean;
  splitBody: any;
  newSuffix: string;
}

export const buildPreviewBody = ({
  detail,
  bodyHasParams,
  splitBody,
  newSuffix,
}: BuildPreviewBodyProps) => {
  if (!detail?.cuerpo) return "";
  if (!bodyHasParams) return String(newSuffix ?? "");

  const original = detail.cuerpo;
  const tokens = splitBody(original);

  const lastTextIndex = (() => {
    for (let i = tokens.length - 1; i >= 0; i -= 1) {
      if (tokens[i]?.type === "text") return i;
    }
    return -1;
  })();

  const updated = tokens.map(
    (
      t: {
        type: "text" | "param";
        value: string;
      },
      idx: number,
    ) => {
      if (idx !== lastTextIndex) return t.value;
      return String(newSuffix ?? "");
    },
  );

  const withEditedSegment = updated.join("");
  return withEditedSegment.replaceAll(
    /\{\d+\}/g,
    `${detail.formatoIdentificador ?? ""}X`,
  );
};

export const pickFirst = (v: any) => {
  return Array.isArray(v) ? v?.[0] : v;
};
export const buildCodeIndexMap = () => {
  const map = new Map<string, string>();
  map.set(CodigosNotificacion.FinancieraEfectivoDisponible, "FINANZAS");
  map.set(CodigosNotificacion.FinancieraEfectivoInfoSolicitada, "FINANZAS");
  map.set(CodigosNotificacion.FinancieraChequeDisponible, "FINANZAS");
  map.set(CodigosNotificacion.FinancieraChequeInfoSolicitada, "FINANZAS");
  map.set(
    CodigosNotificacion.FinancieraTransferenciaProgramadaEjecutada,
    "FINANZAS",
  );
  map.set(
    CodigosNotificacion.FinancieraTransferenciaInternaRecibida,
    "FINANZAS",
  );
  map.set(CodigosNotificacion.FinancieraFondosACvu, "SECCIONES PERFIL");
  map.set(CodigosNotificacion.FinancieraCvuDesasignado, "SECCIONES PERFIL");
  map.set(CodigosNotificacion.FinancieraSaldoProyectadoNegativo, "FINANZAS");
  map.set(CodigosNotificacion.FinancieraFacturasVencidas, "FINANZAS");

  map.set(CodigosNotificacion.GranarioOrdenVentaConfirmada, "GRANARIA");
  map.set(CodigosNotificacion.GranarioOrdenVentaEnNegociacion, "GRANARIA");
  map.set(CodigosNotificacion.GranarioVentaFuturaConfirmada, "GRANARIA");
  map.set(CodigosNotificacion.GranarioVentaFuturaEnNegociacion, "GRANARIA");
  map.set(CodigosNotificacion.GranarioContraEntregaConfirmada, "GRANARIA");
  map.set(CodigosNotificacion.GranarioContraEntregaEnNegociacion, "GRANARIA");
  map.set(CodigosNotificacion.GranarioCupoAsignado, "GRANARIA");
  map.set(CodigosNotificacion.GranarioUltimasEntregas, "GRANARIA");
  map.set(CodigosNotificacion.GranarioDescargasTransito, "GRANARIA");

  map.set(CodigosNotificacion.InsumosPedidoEntregado, "INSUMOS");

  map.set(CodigosNotificacion.OnboardingPjInfoSolicitada, "SECCIONES PERFIL");
  map.set(CodigosNotificacion.OnboardingPjAprobada, "SECCIONES PERFIL");

  return map;
};

export const splitBody = (body: string) => {
  const tokens: { type: "text" | "param"; value: string }[] = [];
  const regex = /\{(\d+)\}/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(body)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({
        type: "text",
        value: body.slice(lastIndex, match.index),
      });
    }
    tokens.push({ type: "param", value: match[0] });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < body.length) {
    tokens.push({ type: "text", value: body.slice(lastIndex) });
  }
  return tokens;
};
